import { ReactNode } from "react";
import "./Spinner.scss";

export interface SpinnerProps {
  size?: number;
  renderContent?: ReactNode;
  color?: "black" | "red";
  position?: "center" | "left";
}

export const Spinner = ({
  size = 2,
  color = "black",
  position="center",
  renderContent,
}: SpinnerProps) => {
  return (
    <div className="Spinner">
      <span
        style={{
          width: size + "rem",
          height: size + "rem",
          borderTop: `${size / 5}rem solid var(${
            color == "red" ? "--home-layout-red" : "--home-layout-background"
          })`,
          borderRight: `${size / 5}rem solid transparent`,
        }}
        className={`Spinner__circle  ${size} ${color} ${position}`}
      ></span>
      <span className="RenderContent">{renderContent}</span>
    </div>
  );
};
export default Spinner;
